import React from "react";
import {
	AiOutlineClockCircle,
	AiOutlineInfoCircle,
	AiOutlineUser
} from "react-icons/ai";
import { FormatDateOptions } from "react-intl";

import { Origin } from "lib/build/events";

import { Coworker } from "src/features/auth";

import "./Title.css";

const formatDateOptions: FormatDateOptions = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "numeric",
	second: "numeric"
};

interface TitleProps {
	users: { [key: string]: Coworker };
	content?: { icon?: React.ReactNode; text: React.ReactNode };
	timestamp?: string;
	origin?: Origin;
	extra?: string;

	formatDate(date: string, options: FormatDateOptions): string;

	formatName(options: {
		title: string;
		firstName: string;
		lastName: string;
	}): string;
}

export function renderTitle({
	users,
	content: originalContent,
	timestamp,
	origin,
	formatDate,
	formatName,
	extra
}: TitleProps): React.ReactNode {
	const content: React.ReactNode[] = [];
	if (originalContent !== undefined) {
		content.push(
			<div className="header-title__line">
				{originalContent.icon !== undefined && (
					<div className="header-title__icon">
						{originalContent.icon}
					</div>
				)}
				{originalContent.text}
			</div>
		);
	}
	if (timestamp !== undefined) {
		content.push(
			<div className="header-title__line">
				<div className="header-title__icon">
					<AiOutlineClockCircle />
				</div>
				{formatDate(timestamp, formatDateOptions)}
			</div>
		);
	}
	if (origin !== undefined && origin.recordedBy in users) {
		content.push(
			<div className="header-title__line">
				<div className="header-title__icon">
					<AiOutlineUser />
				</div>
				{formatName(users[origin.recordedBy])}
			</div>
		);
	}
	if (extra !== undefined) {
		content.push(
			<div className="header-title__line">
				<div className="header-title__icon">
					<AiOutlineInfoCircle />
				</div>
				{extra}
			</div>
		);
	}
	if (content.length === 0) {
		return null;
	}
	return (
		<div className="header-title">
			{content.map((line, i) => (
				<React.Fragment key={i}>{line}</React.Fragment>
			))}
		</div>
	);
}
